import { MatSort } from '@angular/material/sort';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { MatDataSource } from 'src/app/shared-new/util/mat-datasource';
export class SaleHorseListDataSource extends MatDataSource<SaleHorse> {
  public constructor(data: SaleHorse[], sort: MatSort, disableInfiniteScroll: boolean = false,scrollLevel: number = 20) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
    this.setCustomSort();
  }

  private sortOn: string;

  public setSortOn(sortOn: string) {
    this.sortOn = sortOn;
  }

  updateNotesCount(horseId: number, newNotesCount: number): void {
    const saleHorse = this.masterSet.find(x => x.horseId == horseId);
    saleHorse.notesCount = newNotesCount;
    this.updateSaleHorseRow(saleHorse);
  }

  updateSaleHorseRow(saleHorse: SaleHorse): void {
    const updateRow = (array: SaleHorse[], set: SaleHorse) => {
      const index = array.findIndex(x => x.horseId === set.horseId);

      if (index > -1) {

        array[index]  = {
          ...set,
          saleResult: saleHorse.saleResult ?? set.saleResult,
          buyer: saleHorse.buyer ?? set.buyer,
          date: saleHorse.date ?? set.date,
          price: saleHorse.price ?? set.price,
          statusId: saleHorse.statusId ?? set.statusId,
          reservePrice: saleHorse.reservePrice ?? set.reservePrice,
          scopeStatus: saleHorse.scopeStatus,
          scopeStatusId: saleHorse.scopeStatusId,
          submissionStatus: saleHorse.submissionStatus,
          submissionStatusId: saleHorse.submissionStatusId,
          xrayReportStatus: saleHorse.xrayReportStatus,
          xrayReportStatusId: saleHorse.xrayReportStatusId,
          xrayStatus: saleHorse.xrayStatus,
          xrayStatusId: saleHorse.xrayStatusId,
          notesCount: saleHorse.notesCount
        };
        this._updateChangeSubscription();
      }
    };
    updateRow(this.masterSet, saleHorse);
    updateRow(this.currentSet, saleHorse);
    updateRow(this.data, saleHorse);
    updateRow(this.dataset, saleHorse);
    this._filterData(this.masterSet);

  }



  public applyDefaultSort() {
    if (this.sort) {
      this.sort.active = 'lotNumber'; // Set default sorting
      this.sort.direction = 'asc';
      this.sort.sortChange.emit(this.sort);
    }
  }

  setFilterPredicate(): void {
    this.filterPredicate = (saleHorse: SaleHorse, filterValue: string = '') => {
      return 'lot,lotNumber,horseName,consignor,sire,dam,scopeStatus,xrayReportStatus,xrayStatus,saleResult'
        .split(',')
        .some((key) => {
          return (
            saleHorse[key as keyof SaleHorse] &&
            new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
              saleHorse[key as keyof SaleHorse]
            )
          );
        });
    };
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }


  // Custom sort method for a specific column (e.g., 'horseName')
  setCustomSort(): void {
    this.sortingDataAccessor = (saleHorse: SaleHorse, sortHeaderId: string): any => {
      if (sortHeaderId === 'horseName') {
        if (this.sortOn == 'horse') {
          return saleHorse.horseName?.toLowerCase();
        }
        if (this.sortOn == 'sire') {
          return saleHorse.sire?.toLowerCase();
        }
        if (this.sortOn == 'dam') {
          return saleHorse.dam?.toLowerCase();
        }
      }
      // Default sorting for other columns
      return saleHorse[sortHeaderId as keyof SaleHorse];
    };
  }
}
